module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyODguNjEgMTI5LjgxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkNsb3VkU3RvcmFnZV88L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI4OC42MSwxMjkuODFhMTAuMDksMTAuMDksMCwwLDAtMTcuNzktNi41MSw2LjQ0LDYuNDQsMCwwLDAtNi40My02LjA3LDYuMzcsNi4zNywwLDAsMC00LjI3LDEuNjMsMTQsMTQsMCwwLDAtMTkuOTEtMTEuNTMsMzEsMzEsMCwwLDAtNDMtMjAuNTFBOTksOTksMCwwLDAsMCw5OXYzMC44MUgyODguNjFaIi8+PC9zdmc+"


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/cloud_left.svg
 ** module id = 1236
 ** module chunks = 0
 **/